import { HeroConsolidatedProps } from './types';
import HeroBaseVariant from './HeroBaseVariant';
import HeroBlogVariant from './HeroBlogVariant';
import HeroBaseWithBlogVariant from './HeroBaseWithBlogVariant';
import HeroFullBleedVariant from './HeroFullBleedVariant';
import { HeroVariants } from './constants';
import HeroPillarVariant from './HeroPillarVariant';
import HeroCareersVariant from './HeroCareersVariant';

const HeroConsolidated = (props: HeroConsolidatedProps) => {
  const { variant } = props;

  switch (variant) {
    case HeroVariants.Blog:
      return <HeroBlogVariant {...props} />;
    case HeroVariants.BaseWithBlog:
      return <HeroBaseWithBlogVariant {...props} />;
    case HeroVariants.FullBleed:
      return <HeroFullBleedVariant {...props} />;
    case HeroVariants.Pillar:
      return <HeroPillarVariant {...props} />;
    case HeroVariants.Careers:
      return <HeroCareersVariant {...props} />;
    case HeroVariants.Base:
    default:
      return <HeroBaseVariant {...props} />;
  }
};

export default HeroConsolidated;
